import { Scrollbar } from 'shared/ui'
import { DetailsClickToTextBody, DetailsClickToTextHeader } from './Details'
import styles from './styles.module.scss'

export const DetailsClickToTextModalContent = () => {
  return (
    <Scrollbar>
      <div className={styles.wrap}>
        <DetailsClickToTextHeader />
        <DetailsClickToTextBody />
      </div>
    </Scrollbar>
  )
}
